export const getId = (event, $questionSet) => {
  $questionSet =
    $questionSet || event.currentTarget.closest('.js-quizQuestionSet');
  return $questionSet.id;
};
